<template>
  <div id="userGroupList">
    <div class="filter">
      <div @click="createUserGroup" class="btn">创建用户组</div>
      <div>
        <Input
          class="search"
          v-model="search"
          placeholder="请输入用户组名称"
          style
        />
      </div>
      <div @click="seachClick" class="searchBtn">搜索</div>
    </div>
    <div class="table">
      <Table ref="selection" :columns="columns4" :data="list">
        <template slot-scope="{ row, index }" slot="edit">
          <div class="edit">
            <div @click="add(row, index)">添加组成员</div>
            <div @click="addJurisdiction(row, index)">添加权限</div>
            <div @click="remove(row, index)">删除</div>
          </div>
        </template>
      </Table>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <!--    <Button class="addGroup">添加到用户组</Button>-->
    <Modal
      :scrollable="true"
      v-model="alert"
      width="572px"
      class-name="vertical-center-modal"
      :footer-hide="true"
    >
      <div class="alert">
        <template v-if="alertType === 'create'">
          <div class="title">创建用户组</div>
          <Input
            v-model="userGroupName"
            type="text"
            placeholder="请输入用户组名称"
            style="width: 462px; margin-left: 57px; margin-top: 20px"
          />
        </template>
        <template v-if="alertType === 'addUser'">
          <div class="title">添加组成员</div>
          <div class="user">用户组</div>
          <Input
            v-model="value1.roleName"
            style="width: 462px; margin-left: 57px; margin-top: 20px"
            disabled
            placeholder
          />
          <div class="userGroup">
            用户
            <span style="cursor: pointer;" @click="changeGroupType">新建用户+</span>
          </div>

          <Select
            v-model="model1"
            multiple
            style="width: 462px; margin-left: 57px; margin-top: 20px"
          >
            <Option
              v-for="item in userList"
              :value="`${item.id}`"
              :key="item.id"
              >{{ item.account }}
            </Option>
          </Select>
        </template>
        <template v-if="alertType === 'addJurisdiction' && map !== null">
          <div class="title">添加权限</div>
          <div class="user">被授权用户组</div>
          <Input
            v-model="value9"
            style="width: 462px; margin-left: 57px; margin-top: 20px"
            disabled
            placeholder
          />

          <div class="user">选择权限</div>
          <div class="sele" v-for="item in map" :key="item.id">
            <Checkbox
              :indeterminate="item.indeterminate"
              :value="item.checkAll"
              @click.prevent.native="handleCheckAll(item)"
              >{{ item.name }}
            </Checkbox>
            <!--            {{ map }}-->
            <div class="seleList">
              <!--              {{ obj }}-->
              <CheckboxGroup
                v-model="item.checkAllGroup"
                @on-change="checkAllGroupChange(item)"
              >
                <Checkbox
                  v-for="obj in item.children"
                  :key="obj.id"
                  :label="obj.name"
                ></Checkbox>
                <!--                <Checkbox label="西瓜"></Checkbox>-->
              </CheckboxGroup>
            </div>
          </div>
        </template>
        <div class="btn">
          <Button @click="alert = false" class="close">取消</Button>
          <Button v-throttleClick @click="affirm" class="affirm">确认</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Paging from "@/components/paging/index.vue";

export default {
  components: { Paging },
  data() {
    return {
      search: "",
      userList: [],
      model1: [],
      value9: "",
      cityList: [],
      userGroupName: "",
      alertType: "create",
      alert: false,
      value: "",
      columns4: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "用户组名称",
          key: "roleName",
          align: "center",
        },

        {
          title: "创建时间",
          key: "createTime",
          align: "center",
        },
        {
          title: "操作",
          key: "edit",
          slot: "edit",
          align: "center",
        },
      ],
      list: [],
      page: 1,
      value1: {},
      total: 0,
      map: null,
      id: "",
    };
  },
  created() {
    let obj = {
      pageNo: this.page,
      pageSize: 10,
    };
    this.getData(obj);
  },
  methods: {
    changeGroupType() {
      this.$emit("setTypeC", 0);
      this.alert = false
    },
    handleCheckAll(e) {
      if (!e.checkAll) {
        e.children.forEach((item) => e.checkAllGroup.push(item.name));
        e.checkAll = true;
      } else {
        e.checkAllGroup = [];
        e.checkAll = false;
      }
    },
    checkAllGroupChange(data) {
      if (data.checkAllGroup.length === data.children.length) {
        data.checkAll = true;
      } else if (data.length > 0) {
        data.checkAll = false;
      } else {
        data.checkAll = false;
      }
    },
    createUserGroup() {
      this.alertType = "create";
      this.alert = true;
    },
    async affirm() {
      var reg = new RegExp("^[\u4E00-\u9FA5A-Za-z0-9_]+$");
      if (this.alertType === "create") {
        if (this.userGroupName === '') {
          this.$Message.error('请输入用户组名称')
          return
        } else if (!reg.test(this.userGroupName)) {
          this.$Message.error('用户组名称只能输入中文、英文或者数字')
          return
        }
        let res = await this.$apis.userServe.createUserGroup({roleName: this.userGroupName});
        if (res.resultCode === "200") {
          this.$Message.success(res.resultDesc);
          let getDataObj = {
            pageNo: this.page,
            pageSize: 10,
            // roleName: this.value,
          };
          await this.getData(getDataObj);
        } else {
          this.$Message.error(res.resultDesc);
        }
      } else if (this.alertType === "addJurisdiction") {
        let permissionIds = [];
        this.map.forEach((item) => {
          item.checkAllGroup.forEach((obj) => {
            item.children.forEach((chiObj) => {
              if (chiObj.name === obj) {
                permissionIds.push(chiObj.permissionId);
              }
            });
          });
        });
        let obj = {
          roleId: this.id,
          permissionIds,
        };

        if (this.map[0].checkAllGroup.length !== 0) permissionIds.push(2);
        if (this.map[1].checkAllGroup.length !== 0) permissionIds.push(9);
        let res = await this.$apis.userServe.setJurisdiction(obj);
        if (res.resultCode === "200") {
          this.$Message.success(res.resultDesc);
        } else {
          this.$Message.error(res.resultDesc);
        }
      } else if (this.alertType === "addUser") {
        if (this.model1.length === 0) {
          this.$Message.error('请至少选择一位子用户')
          return
        }
        let obj = {
          roleId: this.value1.id,
          subUserIds: this.model1,
          delprior: true,
        };
        let res = await this.$apis.userServe.userAndUserGroup(obj);
        if (res.resultCode === "200") {
          this.$Message.success(res.resultDesc);
        } else {
          this.$Message.error(res.resultDesc);
          return
        }
      }
      this.alert = false;
    },
    handlePager(e) {
      console.log(e);

      this.page = e;
      this.getData();
    },
    seachClick() {
      let obj = {
        roleName: this.search,
        pageNo: this.page,
        pageSize: 10,
      };
      this.getData(obj);
    },
    async getData(obj) {
      let { data } = await this.$apis.userServe.getUserGroupList(obj);
      let { total } = data;
      this.list = data.list;
      this.total = Number(total);
    },
    async getUserData(obj) {
      console.log(obj);
      let { data } = await this.$apis.userServe.getUserList(obj);
      this.userList = data.list;
      this.userList.forEach(item => {
        if (item.checkedStatus) return this.model1.push(item.id)
      }) 
    },
    add(e) {
      this.value1 = e;
      this.alertType = "addUser";
      this.model1 = []
      this.alert = true;
      this.getUserData({
        roleId: e.id,
      });
    },
    async addJurisdiction(e) {
      this.alertType = "addJurisdiction";
      this.alert = true;
      this.id = e.id;
      this.value9 = e.roleName;
      let result = await this.$apis.userServe.getJurisdiction({
        groupId: e.id,
      });
      let map = result.content.map;
      let res = result.content.map[0];
      delete map[0];
      for (const mapKey in map) {
        res.map((item) => {
          item["checkAll"] = false;
          item["indeterminate"] = false;
          item["checkAllGroup"] = [];
          if (map[mapKey][0].permissionPid == item.id) {
            item["children"] = map[mapKey];
          }
        });
      }
      this.map = res;
      this.map.forEach((item) => {
        if (item.name == '发布') {
          item.children.forEach(i => {
            i.name = i.name + '发布'
          })
        }
        item.children.forEach((obj) => {
          if (obj.flag) {
            item.checkAllGroup.push(obj.name);
          }
        });
        this.checkAllGroupChange(item);
      });
    },
    async remove(e) {
      this.$Modal.confirm({
        title: '操作确认',
        content: `<p>是否删除该‘${e.roleName}’用户组?</p>`,
        onOk: async () => {
          let res = await this.$apis.userServe.deleteUserGroup({ roleId: e.id });
          if (res.resultCode === "200") {
            this.$Message.success(res.resultDesc);
            let getDataObj = {
              pageNo: this.page,
              pageSize: 10,
              // roleName: this.value,
            };
            await this.getData(getDataObj);
          } else {
            this.$Message.error(res.resultDesc);
          }
        },
        onCancel: () => {
          this.$Message.info('已取消删除操作');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  .btn {
    margin-top: 34px;
    width: 100%;
    height: 120px;
    cursor: pointer;
    //background: pink;
    display: flex;
    align-items: center;
    justify-content: center;

    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }

    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 38px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .title {
    margin-left: 57px;
    margin-top: 50px;
    height: 25px;
    font-size: 24px;
    //background: yellow;
    font-family: Microsoft YaHei;
    font-weight: 900;
    color: #333333;
    line-height: 24px;
  }

  .userGroup {
    margin-top: 33px;
    margin-left: 57px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;

    span {
      color: #1b32b3;
      margin-left: 20px;
    }
  }

  .user {
    margin-top: 33px;
    margin-left: 57px;
    //height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333 !important;
  }

  .seleList {
    margin-top: 20px;
    margin-left: 57px;
  }

  .sele {
    margin-top: 33px;
    margin-left: 57px;
  }
}

#userGroupList {
  .addGroup {
    margin-top: 30px;
  }

  .filter {
    width: 670px;
    display: flex;
    justify-content: space-between;

    .searchBtn {
      width: 80px;
      height: 50px;
      background: #4064e1;
      border-radius: 10px;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      cursor: pointer;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
    }

    .btn {
      cursor: pointer;
      width: 141px;
      height: 51px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      text-align: center;
      line-height: 51px;
      background: #f6faff;
      border: 1px solid #c8c8c8;
      border-radius: 10px;
    }

    .search {
      height: 51px;
      width: 401px;
      background: #f6faff;
      //border: 1px solid #c8c8c8;
      border-radius: 10px;
    }

    ::v-deep .search input {
      height: 51px;
      border-radius: 10px;
      // border: 1px solid #c8c8c8;
    }
  }

  .table {
    margin-top: 51px;

    .edit {
      width: 100%;
      display: flex;
      justify-content: space-around;
      //height: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #133eca;

      div {
        cursor: pointer;
      }
    }
  }
}
</style>
